document.addEventListener('DOMContentLoaded', function () {

	document.querySelectorAll('[data-p360-teams]').forEach(function (section) {

		const teamItems = section.querySelectorAll('.team-item');
		const teamCards = section.querySelectorAll('.team-card');

		if (!teamItems.length || !teamCards.length) {
			return;
		}

		function isDesktop() {
			return window.innerWidth >= 1024;
		}

		function activateTeam(teamId) {

			// Remove active from all left items
			teamItems.forEach(item => {
				item.classList.remove('is-active');
				item.setAttribute('aria-selected', 'false');
			});

			// Hide all cards
			teamCards.forEach(card => {
				card.classList.remove('is-active');
			});

			// Activate selected left item
			const activeItem = section.querySelector(
				`.team-item[data-team="${teamId}"]`
			);

			if (activeItem) {
				activeItem.classList.add('is-active');
				activeItem.setAttribute('aria-selected', 'true');
			}

			// Activate matching right card — rAF instead of a magic-number timeout,
			// ties the re-trigger to the actual paint cycle instead of guessing a delay
			const targetCard = section.querySelector(
				`.team-card[data-team-card="${teamId}"]`
			);

			if (targetCard) {
				requestAnimationFrame(function () {
					targetCard.classList.add('is-active');
				});
			}
		}

		// DESKTOP
		// Hover behavior ONLY >= 1024px

		teamItems.forEach(item => {

			item.addEventListener('mouseenter', function () {
				if (!isDesktop()) {
					return;
				}
				activateTeam(this.getAttribute('data-team'));
			});

			// TABLET + MOBILE
			// Click behavior < 1024px

			item.addEventListener('click', function () {
				if (isDesktop()) {
					return;
				}
				activateTeam(this.getAttribute('data-team'));
			});

			// Keyboard — works at every width, since neither hover nor click
			// above covers keyboard users at all right now
			item.addEventListener('keydown', function (e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					activateTeam(this.getAttribute('data-team'));
				}
			});
		});

		// INITIAL STATE

		const initialItem = section.querySelector('.team-item.is-active');

		if (initialItem) {
			const initialTeamId = initialItem.getAttribute('data-team');
			const initialCard = section.querySelector(
				`.team-card[data-team-card="${initialTeamId}"]`
			);

			if (initialCard) {
				initialCard.classList.add('is-active');
			}
		}

		let wasDesktop = isDesktop();

		window.addEventListener('resize', function () {

			const currentlyDesktop = isDesktop();

			if (currentlyDesktop !== wasDesktop) {

				const activeItem = section.querySelector('.team-item.is-active');

				if (activeItem) {
					activateTeam(activeItem.getAttribute('data-team'));
				}
			}

			wasDesktop = currentlyDesktop;
		});

	});

});